<template>
  <div>
    <LeadershipHero />
  </div>
</template>

<script>
import LeadershipHero from "@/components/LeadershipHero.vue";
export default {
  components: {
    LeadershipHero
  }
};
</script>

<style lang="scss" scoped>
h1 {
  color:  #efefef;
}
</style>
